import header from "./terraced-house.webp";
import section1 from "./reihenhaus-2.jpg";
import section2 from "./strasse-mit-reihenhäusern.jpg";
import section3 from "./reihenhaus.jpg";
import section4 from "./entrance-hall-house-with-floating-oak.jpg";
import section5 from "./geräumiges-wohnzimmer-mit-seeblick.jpg";
import section6 from "./bright-clean-modern-bedroom-scandinavian-style.jpg";

export { header, section1, section2, section3, section4, section5, section6 };